import { QueryObject, withQueryString, buildURLObject } from './common';
import { OUR_SERVICES_URL, OUR_SERVICES_AS } from './paths';

export function buildServicesURLObject(query: QueryObject = {}) {
  return buildURLObject(OUR_SERVICES_URL, withQueryString(OUR_SERVICES_AS, query), query);
}
